import TextFieldBase from '../base/TextField';
import createField from './createField';

const TextField = createField(TextFieldBase);

export default TextField;
